/**
 * @author wuyan.geass
 * @description https://bytedance.feishu.cn/wiki/JVfAwkI0hiq1VGknawYcYdOdnxd
 */
import React from 'react';
import { Trans as JupiterTrans } from '@jupiter/plugin-runtime/i18n';
import useTranslation from '../use-translation';

export interface TransProps {
  children?: React.ReactNode;
  /**
   * used to handler i18n content like "content detail, <1>Read More</1>"
   * components: {
   *   1: <span style={ color: blue } onClick={doSomething} />
   * }
   */
  components?:
    | readonly React.ReactNode[]
    | { readonly [tagName: string]: React.ReactNode };
  /**
   * when count = 1, add _singular suffix to starlingKey
   * when count != 1 && count !== undefined, add _plural suffix to starlingKey
   */
  count?: number;
  /**
   * starling key
   */
  i18nKey: string;
}

export type I18nTextProps = TransProps & {
  /**
   * parameters to replace the placeholder,
   * for example:
   * Hello, %s | Hello, {name} | Hello, {{name}}
   * parss parmas:
   * ['Alliance'] | { name: 'Alliance' } | {name: 'Alliance'}
   */
  params?: any[] | Record<string, number | string | undefined>;
  defaultText: string;
};

const I18nText: React.MemoExoticComponent<
  (props: I18nTextProps) => JSX.Element
> = React.memo(
  (
    props: TransProps & {
      params?: any[] | Record<string, number | string | undefined>;
      defaultText: string;
    },
  ) => {
    const [t] = useTranslation();
    const { params, defaultText } = props;

    return (
      <JupiterTrans
        {...props}
        defaults={defaultText}
        t={(key: string, options: any) => t(key, options, params)}
      />
    );
  },
);

export default I18nText;
